module.exports = __webpack_public_path__ + "static/media/godaddy_cinza.dabb1c9d.svg";